/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonBtcFinalityProviderListRequest = {
    term?: string;
    status?: BabylonBtcFinalityProviderListRequest.status;
    sortField?: BabylonBtcFinalityProviderListRequest.sortField;
    sortDirection?: BabylonBtcFinalityProviderListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonBtcFinalityProviderListRequest {

    export enum status {
        FINALITY_PROVIDER_STATUS_INACTIVE = 'FINALITY_PROVIDER_STATUS_INACTIVE',
        FINALITY_PROVIDER_STATUS_ACTIVE = 'FINALITY_PROVIDER_STATUS_ACTIVE',
        FINALITY_PROVIDER_STATUS_JAILED = 'FINALITY_PROVIDER_STATUS_JAILED',
        FINALITY_PROVIDER_STATUS_SLASHED = 'FINALITY_PROVIDER_STATUS_SLASHED',
    }

    export enum sortField {
        VOTING_POWER = 'VOTING_POWER',
        TOTAL_DELEGATION = 'TOTAL_DELEGATION',
        DELEGATION_COUNT = 'DELEGATION_COUNT',
        STAKER_COUNT = 'STAKER_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

